import { useEffect } from 'react';
import { useViewerStore } from '@/state/viewerStore';
import { cn } from '@/lib/cn';

const TOAST_DURATION_MS = 4000;

export function Toaster() {
  const toasts = useViewerStore((s) => s.toasts);
  const removeToast = useViewerStore((s) => s.removeToast);

  useEffect(() => {
    const timers = toasts.map((t) =>
      window.setTimeout(() => removeToast(t.id), TOAST_DURATION_MS),
    );
    return () => timers.forEach(window.clearTimeout);
  }, [toasts, removeToast]);

  return (
    <div className="absolute right-4 bottom-4 z-40 flex flex-col gap-2" aria-live="polite">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            'max-w-xs rounded-md border border-panel-border bg-panel/85 px-3.5 py-2.5 backdrop-blur',
            t.kind === 'error' ? 'border-l-2 border-l-destructive' : 'border-l-2 border-l-accent',
          )}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
